import { FileText, ClipboardCheck, CalendarCheck, Sparkles } from "lucide-react";
import { container, sectionPad, label } from "@/lib/ui";

const STEPS = [
  { icon: FileText, title: "Request Quote", desc: "Tell us about your home and the clean you need — online, by phone or WhatsApp." },
  { icon: ClipboardCheck, title: "Receive Personalised Estimate", desc: "We review your details and prepare a tailored, no-obligation quote." },
  { icon: CalendarCheck, title: "Confirm Booking", desc: "Pick a time that suits you and lock in your clean." },
  { icon: Sparkles, title: "Enjoy A Cleaner Home", desc: "Relax while we get to work — and come home to a spotless space." },
];

export function HowItWorks() {
  return (
    <section className={`${sectionPad} bg-neutralbg`} data-testid="how-it-works">
      <div className={container}>
        <div className="max-w-2xl">
          <span className={label}>How It Works</span>
          <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-bold tracking-tight text-navy">
            A cleaner home in four simple steps
          </h2>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-4 relative">
          <div className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] h-0.5 bg-brandgreen/25" />
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="relative text-center md:text-left" data-testid={`step-${i + 1}`}>
                <div className="relative inline-grid place-items-center w-16 h-16 rounded-2xl bg-white shadow-md border border-gray-100">
                  <Icon className="w-7 h-7 text-brandgreen" strokeWidth={2} />
                  <span className="absolute -top-2 -right-2 grid place-items-center w-7 h-7 rounded-full bg-navy text-white text-xs font-bold">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-navy">{s.title}</h3>
                <p className="mt-2 text-sm text-gray-600 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
